export const getAvatarPlaceholder = (name: string = "") =>
  `https://ui-avatars.com/api/?name=${name}&background=91c3be&color=fff`;
// `https://avatars.dicebear.com/v2/initials/${name}.svg?background=%2391c3be`;
